import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MODAL_SIZES } from 'shared-modules/constants';
import { RUN_NOW_ERROR_MESSAGES } from 'shared-modules/constants/errorMesages';
import { Button, Modal } from '../../../../components';
import styles from './runAllFail.module.scss';

const RunAllFail = ({ isOpen, closeModal, title, info }) => {
  const hasSummary = info.some((item) => item?.summary);
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} size={MODAL_SIZES.WIDTH_512} withoutHeader isErrorNotification>
      <div className={styles.errorIconContainer}>
        <i className={classNames('material-icons-outlined', styles.errorIcon)}>error_outline</i>
      </div>
      <div className={styles.errorMessageTitle}>{title}</div>
      <div className={styles.scrollableInfoContainer}>
        {hasSummary &&
          info
            .filter(({ summary }) => summary)
            ?.map((item) => (
              <div className={styles.errorInfoRow} key={item.summary}>
                {item.summary}
                {item.url && (
                  <a className={styles.link} href={item.url} target="_blank" rel="noopener noreferrer">
                    こちら
                  </a>
                )}
              </div>
            ))}
        {!hasSummary && (
          <div className={styles.errorInfoRow}>稼働ができませんでした。注文状況等を今一度ご確認ください。</div>
        )}
      </div>
      <div className={styles.support}>
        ご不明な点がございましたら、
        <a className={styles.link} href={RUN_NOW_ERROR_MESSAGES.supportURL} target="_blank" rel="noopener noreferrer">
          お客さまサポート
        </a>
        までお問い合わせください。
      </div>
      <div className={styles.buttonContainer}>
        <Button width={400} className={styles.closeErrorModalButton} onClick={closeModal} secondary>
          とじる
        </Button>
      </div>
    </Modal>
  );
};

RunAllFail.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  info: PropTypes.arrayOf(
    PropTypes.shape({
      summary: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

RunAllFail.defaultProps = {
  info: [],
};

export default memo(RunAllFail);
